import { AbstractMounting } from "../campaigns/abstractMounting";
import { MountingItem } from "../campaigns/mountingItem";

export class UnmountingMaster extends AbstractMounting {
    unmountingItems: MountingItem = new MountingItem();
}
